import * as z from 'zod';
import { LooseAutocomplete } from '../helpers/type-helpers';

export const UrgCodeEnum = z.string();
export type UrgCodeEnum = LooseAutocomplete<'ROU' | 'URG'>;
